const borders = {
    conversationLine: '5px',
};
export default borders;
//# sourceMappingURL=borders.js.map